import React from 'react';

/** UserContext for current session user. */

const UserContext = React.createContext();

export default UserContext;
